"use client";

import {
  createContext,
  useContext,
  type ReactElement,
  type ReactNode,
} from "react";

export enum CreferenceRenderMode {
  Resolve = "resolve",
  Literal = "literal",
}

const CreferenceRenderModeContext = createContext<CreferenceRenderMode>(
  CreferenceRenderMode.Resolve,
);

interface CreferenceRenderModeProviderProps {
  children: ReactNode;
  mode: CreferenceRenderMode;
}

export function CreferenceRenderModeProvider({
  children,
  mode,
}: CreferenceRenderModeProviderProps): ReactElement {
  return (
    <CreferenceRenderModeContext.Provider value={mode}>
      {children}
    </CreferenceRenderModeContext.Provider>
  );
}

export function useCreferenceRenderMode(): CreferenceRenderMode {
  return useContext(CreferenceRenderModeContext);
}
